module.exports = __webpack_public_path__ + "img/bandwidth-banner.69b060f.png";